"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation verifyRegistrationEmailCode($email: String!, $code: String!) {
    verifyRegistrationEmailCode(email: $email, code: $code)
  }
`;
exports.default = mutation;
//# sourceMappingURL=verifyRegistrationEmailCode.mutation.js.map